import { useEffect, useState } from "react";
import api from "../../utils/api";

const EMPTY = {
  amount: "",
  recipientName: "",
  recipientEmail: "",
  note: "",
  oneTimeUse: false,
  expiresAt: "",
  image: null,
  type: "gift",
  code: "",
};

export default function AdminCertificates() {
  const [certs, setCerts] = useState([]);
  const [form, setForm] = useState(EMPTY);
  const [editing, setEditing] = useState(null);
  const [loading, setLoading] = useState(true);
  const [msg, setMsg] = useState("");

  const load = () => {
    setLoading(true);
    api
      .get("/admin/certificates")
      .then((r) => setCerts(r.data.data || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  };

  useEffect(load, []);

  const toast = (m) => {
    setMsg(m);
    setTimeout(() => setMsg(""), 3000);
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;

    setForm((f) => ({
      ...f,
      [name]: type === "checkbox" ? checked : type === "file" ? files[0] : value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const formData = new FormData();

      Object.keys(form).forEach((key) => {
        if (form[key] !== null && form[key] !== undefined) {
          formData.append(key, form[key]);
        }
      });

      if (editing) {
        await api.put("/admin/certificates/" + editing, formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        toast("Сертифікат оновлено");
      } else {
        await api.post("/admin/certificates", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });

        toast("Сертифікат створено");
      }

      setForm(EMPTY);
      setEditing(null);
      load();
    } catch (err) {
      toast(err.response?.data?.message || "Помилка");
    }
  };

  const handleEdit = (c) => {
    setEditing(c.id);
    setForm({
      amount: c.amount,
      recipientName: c.recipientName || "",
      recipientEmail: c.recipientEmail || "",
      note: c.note || "",
      oneTimeUse: c.oneTimeUse,
      expiresAt: c.expiresAt ? c.expiresAt.slice(0, 10) : "",
    });
    window.scrollTo(0, 0);
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Видалити сертифікат?")) return;
    await api.delete("/admin/certificates/" + id);
    toast("Видалено");
    load();
  };

  const handleToggle = async (c) => {
    await api.put("/admin/certificates/" + c.id, {
      isActive: !c.isActive,
    });
    load();
  };

  return (
    <div className="admin-section">
      <div className="admin-section-header">
        <h2>🎁 Подарункові сертифікати</h2>
        <p className="admin-section-desc">Створюйте та керуйте подарунковими сертифікатами</p>
      </div>

      {msg && <div className="admin-toast">{msg}</div>}

      <div className="admin-card" style={{ marginBottom: 24 }}>
        <h3 className="admin-card-title">
          {editing ? "Редагувати сертифікат" : "Новий сертифікат"}
        </h3>
        <form onSubmit={handleSubmit} className="admin-form">
          <div className="admin-form-row">
            <div className="admin-form-group">
              <label>Номінал (₴) *</label>
              <input
                name="amount"
                type="number"
                min="1"
                step="1"
                required
                value={form.amount}
                onChange={handleChange}
                placeholder="напр. 1000"
              />
            </div>
            <div className="admin-form-group">
              <label>Ім'я отримувача</label>
              <input
                name="recipientName"
                type="text"
                value={form.recipientName}
                onChange={handleChange}
                placeholder="Ім'я"
              />
            </div>
            <div className="admin-form-group">
              <label>Email отримувача</label>
              <input
                name="recipientEmail"
                type="email"
                value={form.recipientEmail}
                onChange={handleChange}
                placeholder="email@example.com"
              />
            </div>
          </div>
          <div className="admin-form-row">
            <div className="admin-form-group">
              <label>Примітка</label>
              <input
                name="note"
                type="text"
                value={form.note}
                onChange={handleChange}
                placeholder="Нотатка для адміна"
              />
            </div>
            <div className="admin-form-group">
              <label>Термін дії (до)</label>
              <input name="expiresAt" type="date" value={form.expiresAt} onChange={handleChange} />
            </div>
            <div className="admin-form-group">
              <label>Фото сертифіката</label>

              <input type="file" name="image" accept="image/*" onChange={handleChange} />
            </div>
            <div className="admin-form-group" style={{ justifyContent: "flex-end" }}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                  marginTop: "auto",
                  paddingBottom: 10,
                }}
              >
                <select name="type" value={form.type} onChange={handleChange}>
                  <option value="gift">Подарунковий</option>
                  <option value="promo">Постійний / промокод</option>
                </select>
                {form.type === "gift" && (
                  <input
                    name="oneTimeUse"
                    type="checkbox"
                    checked={form.oneTimeUse}
                    onChange={handleChange}
                  />
                )}
                Одноразове використання
              </label>
              {form.type === "promo" && (
                <input
                  name="code"
                  type="text"
                  value={form.code}
                  onChange={handleChange}
                  placeholder="Введіть код"
                />
              )}
            </div>
          </div>
          <div style={{ display: "flex", gap: 12 }}>
            <button type="submit" className="admin-btn admin-btn--primary">
              {editing ? "✓ Зберегти" : "+ Створити"}
            </button>
            {editing && (
              <button
                type="button"
                className="admin-btn"
                onClick={() => {
                  setEditing(null);
                  setForm(EMPTY);
                }}
              >
                Скасувати
              </button>
            )}
          </div>
        </form>
      </div>

      <div className="admin-card">
        <h3 className="admin-card-title">Всі сертифікати ({certs.length})</h3>
        {loading ? (
          <div className="admin-loading">Завантаження...</div>
        ) : certs.length === 0 ? (
          <p className="admin-empty">Сертифікатів ще немає.</p>
        ) : (
          <div className="admin-table-wrap">
            <table className="admin-table">
              <thead>
                <tr>
                  <th>Фото</th>
                  <th>Код</th>
                  <th>Номінал</th>
                  <th>Використано</th>
                  <th>Отримувач</th>
                  <th>Термін дії</th>
                  <th>Статус</th>
                  <th>Дії</th>
                </tr>
              </thead>
              <tbody>
                {certs.map((c) => {
                  const remaining = parseFloat(c.amount) - parseFloat(c.usedAmount || 0);
                  const expired = c.expiresAt && new Date(c.expiresAt) < new Date();
                  return (
                    <tr key={c.id}>
                      <td>
                        {c.image ? (
                          <img
                            src={`${c.image}`}
                            alt=""
                            style={{
                              width: 60,
                              height: 60,
                              objectFit: "cover",
                              borderRadius: 8,
                            }}
                          />
                        ) : (
                          "—"
                        )}
                      </td>
                      <td>
                        {c.CertificateCodes?.length > 0 ? (
                          `${c.CertificateCodes.length} кодів`
                        ) : (
                          <span style={{ opacity: 0.5 }}>— немає —</span>
                        )}
                      </td>
                      <td>{Number(c.amount).toFixed(0)} ₴</td>
                      <td
                        style={{
                          color: remaining < parseFloat(c.amount) ? "var(--terracotta)" : "inherit",
                        }}
                      >
                        {Number(c.usedAmount || 0).toFixed(0)} ₴
                      </td>
                      <td>
                        {c.recipientName && (
                          <div style={{ fontSize: "0.85rem" }}>{c.recipientName}</div>
                        )}
                        {c.recipientEmail && (
                          <div style={{ fontSize: "0.75rem", color: "var(--text-light)" }}>
                            {c.recipientEmail}
                          </div>
                        )}
                      </td>
                      <td style={{ fontSize: "0.85rem", color: expired ? "red" : "inherit" }}>
                        {c.expiresAt ? new Date(c.expiresAt).toLocaleDateString("uk-UA") : "—"}
                      </td>
                      <td>
                        <span
                          className={`admin-status-badge ${c.isActive && !expired ? "active" : "inactive"}`}
                        >
                          {expired ? "Прострочений" : c.isActive ? "Активний" : "Деактив."}
                        </span>
                      </td>
                      <td>
                        <div style={{ display: "flex", gap: 6 }}>
                          <button className="admin-btn admin-btn--sm" onClick={() => handleEdit(c)}>
                            ✏️
                          </button>
                          <button
                            className="admin-btn admin-btn--sm"
                            onClick={() => handleToggle(c)}
                            title={c.isActive ? "Деактивувати" : "Активувати"}
                          >
                            {c.isActive ? "⏸" : "▶"}
                          </button>
                          <button
                            className="admin-btn admin-btn--sm admin-btn--danger"
                            onClick={() => handleDelete(c.id)}
                          >
                            🗑
                          </button>
                        </div>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
